export const CORE_FILE_POLLING_INTERVAL = 10000;
export const TASK_TRIGGER_POLLING_INTERVAL = 2000;

// set max retries to poll for one minute before failing
export const TASK_TRIGGER_POLLING_MAX_RETRY =
  60000 / TASK_TRIGGER_POLLING_INTERVAL;
